import { styled } from "@mui/material";
import { type ImageResizeMode } from "@src/components/imageStatic/ImageStatic";

interface ImageProps {
    imageHeight?: number;
    imageWidth?: number;
    resizeMode: ImageResizeMode;
}

export const StyledImage = styled("img")<ImageProps>(({ resizeMode, imageWidth, imageHeight }) => ({
    objectFit: resizeMode,
    width: imageWidth === undefined ? "auto" : `${imageWidth}px`,
    height: imageHeight === undefined ? "auto" : `${imageHeight}px`,
}));
